import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function BottomPricing() {
  return <section className="py-16 px-4 bg-dark-card border-t border-dark-border pt-[25px] pb-[25px]" data-id="element-71">
      <div className="max-w-lg mx-auto" data-id="element-72">
        {/* Timer header */}
        <div className="text-center mb-10" data-id="element-73">
          <div className="text-white font-bold mb-4 tracking-widest text-sm flex items-center justify-center gap-2" data-id="element-74">
            <span data-id="element-75">🚨</span>
            <span data-id="element-76">EL PRECIO DE LANZAMIENTO CIERRA EN:</span>
          </div>
          <CountdownTimer data-id="element-77" />
        </div>

        {/* Cards */}
        <div className="flex flex-col gap-6" data-id="element-78">
          {/* Card 1 — ULTRAPACK ESTÁNDAR */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark border border-dark-border rounded-2xl p-6 text-center" data-id="element-79">
            <div className="text-3xl mb-2" data-id="element-80">📘</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-81">
              ULTRAPACK ESTÁNDAR
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-82">6 Tomos + 6 Bonos</p>

            <div className="mt-5" data-id="element-83">
              <div className="text-gray-500 line-through text-sm" data-id="element-84">$51.000</div>
              <div className="text-3xl md:text-4xl font-black text-white mt-1" data-id="element-85">
                $19.990
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47722955341998:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(249,115,22,0.3)] text-base" data-id="element-86">
              → QUIERO EMPEZAR YA
            </a>
          </motion.div>

          {/* Card 2 — ULTRAPACK + MÉTODO BOUTIQUE (highlighted) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-dark border-2 border-brand rounded-2xl p-6 text-center shadow-[0_0_40px_rgba(249,115,22,0.15)]" data-id="element-87">
            <div className="text-3xl mb-2" data-id="element-88">🏆</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-89">
              ULTRAPACK + MÉTODO BOUTIQUE <span className="text-brand" data-id="element-90">⭐</span>
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-91">
              6 Tomos + 6 Bonos + Ebook Upsell "Contratos Corporativos"
            </p>

            <div className="mt-5" data-id="element-92">
              <div className="text-gray-500 line-through text-sm" data-id="element-93">$69.000</div>
              <div className="text-3xl md:text-4xl font-black text-brand mt-1" data-id="element-94">
                $27.990
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47722956030126:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(249,115,22,0.4)] text-base" data-id="element-95">
              → QUIERO EL PACK PREMIUM + ESCALA
            </a>
          </motion.div>
        </div>

        {/* Trust badges */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-sm text-gray-500" data-id="element-96">
          <div className="flex items-center space-x-2" data-id="element-97">
            <span data-id="element-98">🔒</span> <span data-id="element-99">Pago 100% seguro</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-100">
            <span data-id="element-101">⚡</span> <span data-id="element-102">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-103">
            <span data-id="element-104">🛡️</span> <span data-id="element-105">Garantía 7 días</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-106">
            <span data-id="element-107">💳</span> <span data-id="element-108">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}